import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, ToastController, ModalController } from 'ionic-angular';
import { User } from '../../model/UserModel';
import { ProjectUserModel } from './../../model/CronosModel';
import { CronosMembersAddPage } from './../cronos-members-add/cronos-members-add';
import { CronosService } from '../../services/CronosService';

import _ from 'lodash';

import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppStore } from '../../store/AppStore';

@IonicPage()
@Component({
  selector: 'page-cronos-members',
  templateUrl: 'cronos-members.html',
})
export class CronosMembersPage {

  public searchInput: string;
  public shouldShowCancelSearch: boolean;
  public users: Array<User>;
  public filteredUsers: Array<User>;
  public originalMembers: Array<ProjectUserModel>;
  public members: Array<ProjectUserModel>;
  public taskId: number;
  public teamId: number;
  public loginUserId: number;
  public clientId: number;

  private userSubscription: Subscription;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private store: Store<AppStore>,
    public viewCtrl: ViewController,
    private modalCtrl: ModalController,
    private toastCtrl: ToastController,
    private cronosService: CronosService
  ) {
    this.users = this.navParams.get('users');
    this.originalMembers = this.navParams.get('members');
    this.members = this.originalMembers.map(x => Object.assign({}, x));
    this.taskId = this.navParams.get('taskId');
    this.teamId = this.navParams.get('teamId');
    this.clientId = this.navParams.get('clientId');
    this.search();
  }

  ionViewWillEnter() {
    this.userSubscription = this.store.select('userState').subscribe(userState => {
      if (userState.user != null) {
        this.loginUserId = userState.user.id;
        this.clientId = userState.user.clienteId;
      }
    });
  }

  search() {
    this.filteredUsers = this.users;
    if (this.searchInput != null && this.searchInput != '') {
      this.filteredUsers = this.users.filter(x => x.nome.indexOf(this.searchInput) >= 0 || x.email.indexOf(this.searchInput) >= 0);
    }
  }

  cancelSearch() {
    this.searchInput = null;
    this.shouldShowCancelSearch = false;
    this.search();
  }

  isMember(user: User) {
    if (this.members.length == 0) {
      return false;
    } else {
      return this.members.find(x => x.userId == user.id) != null;
    }
  }

  changeMember(user: User) {
    if (this.isMember(user)) {
      let member = this.members.find(x => x.userId == user.id);
      if (member != null) {
        this.removeUser(member);
      }
    } else {
      this.addUserInMembers(user);
    }
  }

  addUserInMembers(user: User) {
    const userNames = user.nome.split(' ');
    let initials = null;
    if (userNames.length > 1) {
      initials = userNames[0].substring(0, 1).toUpperCase() + userNames[1].substring(0, 1).toUpperCase();
    } else {
      initials = user.nome.substring(0, 1).toUpperCase();
    }
    if (!this.members) {
      this.members = new Array<ProjectUserModel>();
    }

    let member = {
      id: null,
      taskId: this.taskId,
      userId: user.id,
      userEmail: user.email,
      userName: user.email,
      inviteDate: new Date(),
      initials: initials,
      avatarUrl: user.logoUrl
    }

    this.cronosService.saveUserTask(member, this.loginUserId)
      .subscribe(user => {
        this.members.push(_.assign({}, member, user));
        this.presentToast('Salvo com sucesso');
      });
  }

  removeUser(member) {
    this.cronosService.removeUserTask(member, this.loginUserId)
      .subscribe(() => {
        _.remove(this.members, member);
        this.presentToast('Salvo com sucesso');
      });
  }

  backTask() {
    this.viewCtrl.dismiss((this.members || this.originalMembers));
  }

  addMember() {
    const modal = this.modalCtrl.create(CronosMembersAddPage, { clientId: this.clientId, members: this.members }, { showBackdrop: true });
    modal.onDidDismiss(user => {
      if (user != null) {
        this.users.push(user);
        this.addUserInMembers(user);
      }
    });
    modal.present();
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 2000,
      position: 'bottom'
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/cronos-members/cronos-members.ts